import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ClerkProvider, ClerkLoaded, ClerkLoading } from "@clerk/clerk-react";
import App from "./App.tsx";
import { Provider } from "./provider.tsx";
import ClerkLoaderComp from "./components/loaders/clerk-loader.jsx";
import "@/styles/globals.css";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Publishable Key')
}


const APP_VERSION = '0.0.1'

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
  });
}

(async () => {
  const prev = localStorage.getItem("app_version");
  if (prev && prev !== APP_VERSION) {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    } catch {}
  }
  localStorage.setItem("app_version", APP_VERSION);
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
  <BrowserRouter>
    <Provider>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
        <ClerkLoading>
          <div className="flex items-center justify-center h-screen w-screen">
              <ClerkLoaderComp />
          </div>
        </ClerkLoading>

        <ClerkLoaded>
          <App />
        </ClerkLoaded>
      </ClerkProvider>
    </Provider>
  </BrowserRouter>
</React.StrictMode>,
);
